import React from 'react';
import {Container, Row, Col} from 'react-bootstrap';
import {Chrono}  from 'react-chrono';

const timeline_json = [
    {title :"2014", cardSubtitle :"Adjudicación Fondo de Desarrollo Institucional (FDI) para la compra de las primeras máquinas."},
    {title :"2015", cardSubtitle :"Incorporación profesor Maximiliano Rivera al equipo."},
    {title :"2017", cardSubtitle :"Llegada equipamiento, y apertura oficial y masiva de FabLab."},
    {title :"2019", cardSubtitle :"Generación de protocolos de uso FabLab UTFSM. Capacitación Fab Academy José Tomás Dominguez."},
    {title :"2020", cardSubtitle :"Covid 19. Visibilización, generación de proyectos de alto impacto, con el apoyo de Scotiabank. Adjudicación FDI."},
    {title :"FUTURO", cardSubtitle :"Inspirar a jóvenes emprendedores a innovar junto a FabLab UTFSM."},
]

export const Timeline = () => {

  return (
    <Container className="fablab-container" id="historia">
      <Row>
        <Col>
          <h1 className="fablab-title">Historia</h1>
        </Col>
      </Row>
      
      <Row>
        <Col>
          <Chrono items={timeline_json} mode="VERTICAL" cardHeight="auto" />
        </Col>
      </Row>
    </Container>
  )
}
